const alphabetCreation = (index: number, isUppercase: boolean) => {
  const baseCode = isUppercase ? 65 : 97;
  return String.fromCharCode(baseCode + index);
};

export default alphabetCreation;
